import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles((theme) => ({
  wrapper: {
    height: "calc(100vh - 206px)",
    overflowY: "auto",
    width: "100%",
    paddingBottom: 90,
    backgroundColor: "#f8fafc",
  },
  sidebarItems: {
    paddingLeft: 32,
    "&:hover": {
      background: "transparent",
    },
  },
  sidebarItemsText: {
    "& span": {
      fontFamily: "'Manrope', sans-serif",
      fontSize: "16px !important",
      fontWeight: "bold",
      lineHeight: "24px",
      color: "#93a9bd",
    },
    "&.active": {
      "& span": {
        color: "#465869",
      },
    },
  },
  sidebarSubItem: {
    paddingTop: 0,
    paddingBottom: 0,
    "&:hover": {
      background: "transparent",
    },
  },
  sidebarSubItemText: {
    padding: "10px 24px 10px 16px",
    "&.active": {
      background: getBrandCustom("headerBackgroundColor", "#edf5fb"),
      borderRadius: 8,
      "& span": {
        color: getBrandCustom("primaryColor", "#308CDB"),
      },
    },
  },
  sidebarForwardIcon: {
    background: getBrandCustom("primaryColor", "#308CDB"),
    color: "#fff",
    borderRadius: 20,
    padding: ".25rem",
    cursor: "pointer",
  },
}));

export default styles;
